//? Import the necessary types from the types file
import { type QuestionLifecycle } from "./types/types";

//* Import the data-fetching library
import { useQuery } from "@tanstack/react-query";

//* Import the questionAPI object that performs the HTTP call
import { questionAPI } from "./questionsAPI";

/**
 * Loads the lifecycle analytics for a single question.
 *
 * When `applicationId` is provided the payload also carries the stats scoped
 * to that application; changing it triggers a refetch via the query key.
 */
export const useQuestionLifecycle = (
	token: string,
	id?: string,
	applicationId?: string
) => {
	const { data, isLoading, isFetching, isError, error, refetch } =
		useQuery<QuestionLifecycle>({
			queryKey: ["questions", "lifecycle", id, applicationId ?? null],
			queryFn: () => questionAPI.getLifecycle(id as string, token, applicationId),
			enabled: !!token && !!id,
			staleTime: 5 * 60 * 1000,
		});

	return {
		lifecycle: data,
		loading: isLoading,
		fetching: isFetching,
		isError,
		error,
		refetch,
	};
};
